import fieldConfig from '@/configs/fileds';

export const createdRangeInput = function fn(item, RangeInput) {
  let readonly = fieldConfig[item.key].readonly || false;
  if (item.key === 'referrer') {
    readonly = this.support;
  }
  this.cacheComps.push({
    component: RangeInput,
    label: fieldConfig[item.key].label,
    model: item.key,
    placeholder:
      item.min && item.max
        ? `${item.min}-${item.max}`
        : fieldConfig[item.key].placeholder,
    reg: fieldConfig[item.key].reg,
    readonly,
    min: item.min,
    max: item.max,
    amountCompany: item.min && item.max ? '万元' : '',
    maxlength: fieldConfig[item.key].maxlength,
    toUpperCase: fieldConfig[item.key].toUpperCase,
    class:
     (item.key === 'borrowerName' || item.key === 'loanAmount')
       ? 'marginTop'
       : 'term',
  });
};
export const createdloanAmountInput = function fn(item, loanAmountInput) {
  this.cacheComps.push({
    component: loanAmountInput,
    label: fieldConfig[item.key].label,
    model: item.key,
    placeholder:
      item.min && item.max
        ? `${item.min}-${item.max}`
        : fieldConfig[item.key].placeholder,
    reg: fieldConfig[item.key].reg,
    min: item.min,
    max: item.max,
    amountCompany: '万元',
    class: item.key === 'loanAmount' ? 'term' : '',
  });
};

// createAmountInput
export const createdBWSelect = function fn(item, BWSelect) {
  this.cacheComps.push({
    component: BWSelect,
    label: fieldConfig[item.key].label,
    model: item.key,
    placeholder: fieldConfig[item.key].placeholder,
    columnsTerm: item.values,
  });
};
export function createdRelatedSelect(item, RelatedSelect) {
  let { values } = item;
  let { key } = item;
  key = 'marriageRelationshipWith';
  values = {
    valuesEmerRelation: [...item.valuesEmerRelation],
    valuesMarriageStatus: [...item.valuesMarriageStatus],
  };
  this.cacheComps.push({
    component: RelatedSelect,
    label: item.key,
    model: key,
    placeholder: item.key,
    columnsTerm: values,
  });
}

export const createdLocatedPlacePicker = function fn(item, LocatedPlacePicker) {
  this.cacheComps.push({
    component: LocatedPlacePicker,
    label: fieldConfig[item.type].label,
    model: 'LocatedPlacePicker',
    placeholder: fieldConfig[item.type].placeholder,
    columnsTerm: '',
    reg: fieldConfig[item.type].reg,
  });
};

export const createdLivingPlacePicker = function fn(item, LivingPlacePicker) {
  this.cacheComps.push({
    component: LivingPlacePicker,
    label: fieldConfig[item.type].label,
    model: 'livingBorrowerAddress',
    placeholder: fieldConfig[item.type].placeholder,
    columnsTerm: '',
    reg: fieldConfig[item.type].reg,
  });
};

export const createdMessageCode = function fn(item, MessageCode) {
  this.cacheComps.push({
    component: MessageCode,
    label: fieldConfig[item.key].label || '',
    model: item.key,
    placeholder: fieldConfig[item.key].placeholder || '',
    columnsTerm: item.values || [],
    readonly: fieldConfig[item.key].readonly || false,
    reg: fieldConfig[item.key].reg || [],
  });
};

export const createdCompanySelect = function fn(item, CompanySelect) {
  this.cacheComps.push({
    component: CompanySelect,
    label: fieldConfig[item.key].label || '',
    model: item.key,
    placeholder: fieldConfig[item.key].placeholder || '',
    columnsTerm: item.values || [],
    readonly: fieldConfig[item.key].readonly || false,
    reg: fieldConfig[item.key].reg || [],
    class: item.key === 'corpName' ? 'marginTop' : '',
  });
};

// 收入 - 元
export const createOperatingIncomeInput = function fn(item, RangeInput) {
  let readonly = fieldConfig[item.key].readonly || false;
  this.cacheComps.push({
    component: fieldConfig[item.key].type,
    label: fieldConfig[item.key].label,
    model: item.key,
    placeholder:
      item.min && item.max
        ? `${item.min}-${item.max}`
        : fieldConfig[item.key].placeholder,
    reg: fieldConfig[item.key].reg,
    readonly,
    min: item.min,
    max: item.max,
    amountCompany: fieldConfig[item.key].unit,
    maxlength: item.maxlength,
    toUpperCase: fieldConfig[item.key].toUpperCase
  });
};

// 人数
export const createPeopleUnitInput = function fn(item, RangeInput) {
  let readonly = fieldConfig[item.key].readonly || false;
  this.cacheComps.push({
    component: fieldConfig[item.key].type,
    label: fieldConfig[item.key].label,
    model: item.key,
    placeholder: fieldConfig[item.key].placeholder,
    reg: fieldConfig[item.key].reg,
    readonly,
    min: item.min,
    max: item.max,
    labelWidth: fieldConfig[item.key].labelWidth,
    amountCompany: fieldConfig[item.key].unit,
    maxlength: item.maxlength,
    toUpperCase: fieldConfig[item.key].toUpperCase
  });
};

// 电话-可能同时支持座机及手机号
export const createPhoneInput = function fn(item, RangeInput) {
  let readonly = fieldConfig[item.key].readonly || false;
  this.cacheComps.push({
    component: fieldConfig[item.key].type,
    label: fieldConfig[item.key].label,
    model: item.key,
    placeholder: fieldConfig[item.key].placeholder,
    reg: fieldConfig[item.key].reg,
    readonly,
    min: item.min,
    max: item.max,
    labelWidth: fieldConfig[item.key].labelWidth,
    amountCompany: fieldConfig[item.key].unit,
    maxlength: item.maxlength,
    toUpperCase: fieldConfig[item.key].toUpperCase
  });
};
